import { render } from "./Disabled.vue?vue&type=template&id=3d2f2dd1&scoped=true"
const script = {}

import "./Disabled.vue?vue&type=style&index=0&id=3d2f2dd1&lang=scss&scoped=true"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2f2dd1"]])

export default __exports__